import { SearchOutlined } from "@ant-design/icons";
import { Badge, Button, Input, Modal, Select, Table, Tooltip } from "antd";
import Column from "antd/es/table/Column";
import { API_LIST_CONVERSATION } from "api/chat-support";
import { CONSTANTS } from "config/constant";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import profile from "../../../assets/img/orders/orderDetail/userplace.png";
import Chat from "components/Chat";
import { useSocket } from "config/SocketContext";
import { CONVERSATION_LISTING } from "api/chat-support";
import { API_SEND_MESSAGE } from "api/chat-support";
import { useLocation } from "react-router-dom";
import { CONVERSATION_SEEN } from "api/chat-support";

function CustomerSupportTable() {
  const { connect, disconnect, isOnline, socket } = useSocket();
  const [filters, setFilters] = useState({
    type: "",
    member: "",
    name: "",
  });
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [hasOpened, setHasOpened] = useState(false); // Track if modal was opened by URL

  const [conversationLoading, setConversationLoading] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [datas, setDatas] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const { t } = useTranslation();
  const location = useLocation();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  // Extract the search parameters from the URL
  const searchParams = new URLSearchParams(location.search);

  // Get the conversation_id from the query params
  const conversationId = searchParams.get("conversation_id");
  const fetchListing = async () => {
    try {
      setLoading(true);
      const res = await API_LIST_CONVERSATION({
        type: filters?.type,
        role: filters?.member,
        name: filters?.name,
        page: pagination.current,
        limit: pagination.pageSize,
      });
      if (res) {
        setLoading(false);
        console.log(res?.conversations, "responslajdfhlajkdfdsjk");
        setDatas(res?.conversations);
        setPagination({ ...pagination, total: res?.total_items });
      }
    } catch (err) {}
  };

  const handleSelectFilter = (value) => {
    console.log(`selected ${value}`);
    setFilters({ ...filters, member: value });
  };
  const handleRespondedFilter = (value) => {
    console.log(`selected ${value}`);
    setFilters({ ...filters, type: value });
  };
  const handleSearch = (value) => {
    setFilters({ ...filters, name: value });
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSend = async () => {
    const payLoad = {
      message: input,
      conversation_id: selectedConversation,
    };
    try {
      const res = await API_SEND_MESSAGE(payLoad);
      if (res) {
        if (input.trim()) {
          setMessages((prevMessages) => [...prevMessages, res?.data]);
          console.log(res?.data, "conversationId");
          setInput("");
        }
        fetchListing();
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (socket) {
      socket.on("message", (data) => {
        console.log(
          selectedConversation,
          data.message.conversation_id,
          "dfljasdhlfkjsdhafka"
        );
        setMessages((prevMessages) => [...prevMessages, data?.message]);
        console.log("sasasasa", data);

        // If the message belongs to the current conversation, update the last message in the table
        if (data?.message?.conversation_id == data?.conversation?._id) {
          console.log("hello from indide");
          fetchListing();

          // Update the specific row with the new message and set unread status
          // setDatas((prevData) =>
          //   prevData.map((item) =>
          //     data?.message?.conversation_id == data?.conversation?._id
          //       ? {
          //           ...item,
          //           last_message: {
          //             ...item.last_message,
          //             text: data?.message?.text,
          //           },
          //           isUnread: true, // Set unread flag for the new message
          //         }
          //       : item
          //   )
          // );

          // setDatas((prevData) =>
          //   prevData.map(
          //     (item) =>
          //       data?.message?.conversation_id === data?.conversation?._id
          //         ? {
          //             ...item,
          //             last_message: {
          //               ...item.last_message,
          //               text: data?.message?.text, // Update the last message text
          //             },
          //           }
          //         : item // Return the unchanged item if no match
          //   )
          // );
        }
      });
      return () => {
        socket.off("message");
      };
    }
  }, [socket]);

  const handleModalData = async (id) => {
    try {
      console.log("xcasdaskda", id);
      setConversationLoading(true);
      setIsChatVisible(true);
      setSelectedConversation(id);
      const res = await CONVERSATION_LISTING({ id });
      if (res) {
        console.log(res, "responsfasdflasdj");
        setConversationLoading(false);
        setMessages(res.messages);

        let seen = await CONVERSATION_SEEN(id); // Call API to mark as seen

        if (seen) {
          fetchListing();
          // setDatas((prevData) =>
          //   prevData.map((item) =>
          //     item?._id === id
          //       ? { ...item, isUnread: false } // Mark as read in state
          //       : item
          //   )
          // );
        }
      }
    } catch (err) {}
  };

  // Automatically open the modal if id in params matches any conversation _id
  useEffect(() => {
    if (conversationId && !hasOpened) {
      const matchedConversation = datas?.find(
        (conversation) => conversation?._id === conversationId
      );
      if (matchedConversation) {
        console.log("hey from insode");
        if (conversationId) {
          handleModalData(conversationId); // Automatically open modal if the param id matches
          setHasOpened(true); // Mark modal as opened
        }
      }
    }
  }, [conversationId, datas, hasOpened]);

  useEffect(() => {
    fetchListing();
  }, [
    filters?.member,
    filters?.type,
    filters?.name,
    pagination?.current,
    pagination?.pageSize,
  ]);
  console.log("pagination", pagination);
  return (
    <div>
      <div className="flex w-full flex-grow flex-row items-center gap-5 sm:w-auto">
        <Input
          className="w-[300px] border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
        />
        <div className="flex flex-row items-center gap-5">
          <Select
            defaultValue={t("All")}
            style={{ width: 120 }}
            onChange={handleSelectFilter}
            options={[
              { value: "", label: t("All") },
              { value: "laundry-man", label: t("Laundry Man") },
              { value: "user", label: t("User") },
            ]}
          />
          <Select
            defaultValue={t("All")}
            style={{ width: 120 }}
            onChange={handleRespondedFilter}
            options={[
              { value: "", label: t("All") },
              { value: "responded", label: t("Responded") },
              { value: "unresponded", label: t("Unresponded") },
            ]}
          />
        </div>
      </div>

      <div className="mt-5">
        <Table
          dataSource={datas}
          pagination={pagination}
          // loading={loading}
          onChange={handleTableChange}
          // rowKey={(record) => record.id}
          // rowClassName={getRowClassName}
          scroll={{ x: true }}
        >
          {/* <Column
            title={t("sr#")}
            dataIndex="plan_title"
            key="plan_title"
            width={"5rem"}
            render={(text, record, index) => (index + 1) * pagination?.current}
          /> */}
          <Column
            title={t("Profile Image")}
            dataIndex="coupon_code"
            key="members"
            width={"9rem"}
            render={(text, record) => (
              <span>
                {record?.members?.map((element, idx) => {
                  return (
                    <div key={idx}>
                      {idx === 0 ? (
                        <div>
                          <img
                            src={
                              element?.member_info?.profile_image?.[0]?.file_url
                                ? CONSTANTS?.IMG_DIRECTORY +
                                  element?.member_info?.profile_image?.[0]
                                    ?.file_url
                                : profile
                            }
                            alt=""
                            style={{
                              width: "4rem",
                              height: "4rem",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </span>
            )}
          />
          <Column
            title={t("Name")}
            className="name-support"
            dataIndex="coupon_code"
            key="coupon_code"
            width={"9rem"}
            // render={(text, record) => (
            //   <div>
            //     <div>
            //       {record?.members?.map((element, idx) => (
            //         <div key={idx}>
            //           {" "}
            //           {element?.member_role === "laundry-man" ||
            //           element?.member_role === "user"
            //             ? `${element?.member_info?.first_name}  ${element?.member_info?.last_name}`
            //             : null}
            //         </div>
            //       ))}
            //     </div>{" "}
            //   </div>
            // )
            render={(text, record) => (
              <Badge
                dot={isChatVisible ? false : !record?.is_seen_by_me} // Show badge if the conversation has unread messages
                offset={[10, 0]}
              >
                {record?.members?.map((element, idx) => (
                  <div key={idx}>
                    {element?.member_role === "laundry-man" ||
                    element?.member_role === "user"
                      ? `${element?.member_info?.first_name}  ${element?.member_info?.last_name}`
                      : null}
                  </div>
                ))}
              </Badge>
            )}
          />
          <Column
            title={t("Email")}
            dataIndex="coupon_title"
            key="email"
            width={"9rem"}
            render={(text, record) => (
              //   <span>{record?.members[0]?.member_info?.email}</span>
              <div>
                {record?.members?.map((element, idx) => (
                  <div key={idx}>
                    {" "}
                    {element?.member_role === "laundry-man" ||
                    element?.member_role === "user"
                      ? element?.member_info?.email
                      : null}
                  </div>
                ))}
              </div>
            )}
          />
          <Column
            title={t("Role")}
            dataIndex="coupon_discount"
            key="role"
            width={"9rem"}
            render={(text, record) => (
              //   <span>{record?.members[0]?.member_role}</span>
              <div>
                {record?.members?.map((element, idx) => (
                  <div key={idx}>
                    {" "}
                    {element?.member_role === "laundry-man" ||
                    element?.member_role === "user"
                      ? element?.member_role?.toUpperCase()
                      : null}
                  </div>
                ))}
              </div>
            )}
          />
          <Column
            title={t("Last Message")}
            dataIndex="last_message"
            key="last_message"
            width={"9rem"}
            render={(text, record) => (
              <Tooltip title={record?.last_message?.text}>
                {record?.last_message?.text?.length > 20
                  ? `${record?.last_message?.text?.substring(0, 20)}...`
                  : record?.last_message?.text}
              </Tooltip>
            )}
          />
          <Column
            title={t("Actions")}
            key="actions"
            width={"9rem"}
            render={(text, record) => (
              <div>
                <Button
                  onClick={() => {
                    handleModalData(record?._id);
                  }}
                  type="primary"
                >
                  {" "}
                  {record?.members[0]?.members_count === 1
                    ? t("Un-Responded")
                    : t("Reply")}{" "}
                </Button>
              </div>
            )}
          />
        </Table>
        <Modal
          centered
          visible={isChatVisible}
          onCancel={() => setIsChatVisible(false)}
          title={
            <span className="text-[20px] text-blue-500">
              {" "}
              {`${messages[0]?.sender_info?.first_name} ${messages[0]?.sender_info?.last_name}`}
            </span>
          }
        >
          <div className="">
            <Chat messages={messages} loading={conversationLoading} />
            <div className="mb-2 mt-2 rounded-lg border  p-2 ">
              <div className="flex">
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  className="flex-1 rounded-l-lg border border-gray-300 p-2 outline-none"
                  placeholder="Type a message"
                />
                <button
                  onClick={handleSend}
                  disabled={!input}
                  className={`rounded-r-lg   p-2 ${input ? " text-white bg-blue-500 hover:bg-blue-600" : "text-black bg-gray-500"} `}
                >
                  {t("Send")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default CustomerSupportTable;
